enum ProcessItemType {
    ArtworkLogo = 1,
    OptionName = 2,
    OptionNumber = 3,
    OptionGroup = 4,
    OptionExclusiveGroup = 5,
}

export { ProcessItemType };
